function getSubmitButtons(form) {
  var buttons = form.querySelectorAll('button, input');
  var submitButtons = [];

  for (var i = 0; i < buttons.length; i++) {
    var button = buttons[i];
    if (button.getAttribute('type') == 'submit') {
      submitButtons.push(button);
    }
  }

  return submitButtons;
}

function renderReCaptcha(form, callback) {
  grecaptcha.ready(function () {
    const recaptchaWidget = form.querySelector('.js-recaptcha');

    if (recaptchaWidget) {
      const widgetId = grecaptcha.render(recaptchaWidget, {
        size: 'invisible',
        badge: 'inline',
        callback: function () {
          callback(widgetId);
        },
        sitekey: recaptchaWidget.getAttribute('data-site-key'),
      });

      getSubmitButtons(form).forEach(function (button) {
        button.addEventListener('click', function (e) {
          if (form.checkValidity() === true){
          e.preventDefault();
          grecaptcha.execute(widgetId);
          }
        });
      });
    }
  });
}
